import React from "react";

import classNames from "classnames";
import { Button } from "react-bootstrap";

import DownloadButton from "./DownloadButton";
import { useFiltersContext } from "../contexts/Filters";

import SelectItemsPerPage from "../../../../../../components/SelectItemsPerPage";

const FiltersSubRow = (): React.JSX.Element => {
    const { setFilters } = useFiltersContext();
    return (
        <div className={classNames("filterSubRow")}>
            <SelectItemsPerPage />
            <DownloadButton />
            <Button
                style={{ marginLeft: "auto" }}
                onClick={() =>
                    setFilters({
                        umpire: undefined,
                        count: 0,
                        attitude: undefined,
                        consistency: undefined,
                        effort: undefined,
                        overall: undefined,
                    })
                }
            >
                Clear Filters
            </Button>
        </div>
    );
};

export default FiltersSubRow;
